import axios from "axios";
import { ApiEndpoints } from "./ApiConstants";

const apiService = axios.create({
    baseURL: ApiEndpoints.BASE_URL,
    headers: {
        'token': process.env.REACT_APP_TOKEN
    },
    params: {
        rule: process.env.REACT_APP_RULE
    }
});

export default apiService;